































































import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiReferencesTypesHierarchyDoctor from '@/components/UI/references-types-hierarchy/doctor.vue';
import UiReferencesTypesHierarchyTeam from '@/components/UI/references-types-hierarchy/team.vue';
import IDoctor from '@/interfaces/doctor';
import {
  REFERENCE_TYPE_CLIENT,
  REFERENCE_TYPE_DOCTOR,
  REFERENCE_TYPE_PATIENT, REFERENCE_TYPE_TEAM
} from '@/settings/consts/rules-engine';
import UiReferencesTypesHierarchyPatient from './patient.vue';

@Component({
  components: {
    UiAutocompleClientsSubsidiaries,
    UiReferencesTypesHierarchyDoctor,
    UiReferencesTypesHierarchyTeam,
    UiReferencesTypesHierarchyPatient
  },
})
export default class UiReferencesTypesHierarchy extends BaseComponent {
  @Prop()
  public item: any;
  @Prop({
    default: {},
  })
  public rules: any;
  @Prop({
    default: () => [
      REFERENCE_TYPE_TEAM,
      REFERENCE_TYPE_CLIENT,
      REFERENCE_TYPE_DOCTOR,
      REFERENCE_TYPE_PATIENT,
    ],
  })
  public hierarchyLevels?: string[];
  @Prop({
    default: false,
  })
  public disabled: boolean;

  public activeTab: string = 'tab-reference-client';
  public referencesTypes = {
    team: REFERENCE_TYPE_TEAM,
    client: REFERENCE_TYPE_CLIENT,
    doctor: REFERENCE_TYPE_DOCTOR,
    patient: REFERENCE_TYPE_PATIENT,
  };

  get doctorRules(): any {
    const rules = {
      doctor: [],
      clientUnit: [],
    };

    if (this.activeTab === 'tab-reference-doctor') {
      rules.doctor = this.rules.doctor;
      rules.clientUnit = this.rules.clientUnit;
    }

    return rules;
  }

  get teamRules(): any {
    const rules = {
      team: [],
      clientUnit: [],
    };

    if (this.activeTab === 'tab-reference-team') {
      rules.team = this.rules.team;
      rules.clientUnit = this.rules.clientUnit;
    }

    return rules;
  }

  get patientRules(): any {
    const rules = {
      patient: [],
      clientUnit: [],
    };

    if (this.activeTab === 'tab-reference-patient') {
      rules.patient = this.rules.patient;
      rules.clientUnit = this.rules.clientUnit;
    }

    return rules;
  }

  @Watch('item')
  public onItemChange(val): void {
    if (!!val) {
      if (val.hierarquia !== REFERENCE_TYPE_CLIENT) {
        this.item.referenciaHierarquia = !!val.referenciaHierarquia
          ? val.referenciaHierarquia.id
          : null;
      }
      this.setActiveTab(val.hierarquia);
    }
  }

  @Watch('activeTab')
  public onActiveTabChange(val: string): void {
    this.setHierarchy(this.activeTab);
    this.setReferenciaHierarquia();
  }

  @Watch('item.unidade')
  public onClientChange(): void {
    this.setHierarchy(this.activeTab);

    this.setReferenciaHierarquia();
  }

  @Watch('item.referenciaHierarquia')
  public onReferenciaHierarquiaChange(): void {
    this.setHierarchy(this.activeTab);
  }

  public onClickTab(): void {
    this.item.referenciaHierarquia = null;
  }

  public onChangeDoctor(doctor: IDoctor): void {
    this.item.referenciaHierarquia = !!doctor ? doctor.id : null;
  }

  public onChangeTeam(team: string): void {
    this.item.referenciaHierarquia = team;
  }

  public onChangePatient(patient: string): void {
    this.item.referenciaHierarquia = patient;
  }

  public onChangeClientUnit(clientUnit): void {
    this.item.unidade = clientUnit;
  }

  public beforeMount(): void {
    this.onItemChange(this.item);
    this.setHierarchy(this.activeTab);
    this.setReferenciaHierarquia();
  }

  public inHierarchyLevels(reference: string): boolean {
    const notFound = -1;
    return this.hierarchyLevels.indexOf(reference) !== notFound;
  }

  private setReferenciaHierarquia(): void {
    if (this.item.hierarquia === REFERENCE_TYPE_CLIENT) {
      this.item.referenciaHierarquia = !!this.item.unidade
        ? this.item.unidade.id
        : null;
    }
  }

  private setHierarchy(tab: string): void {
    let hierarchy;
    switch (tab) {
      case 'tab-reference-team':
        hierarchy = REFERENCE_TYPE_TEAM;
        break;
      case 'tab-reference-doctor':
        hierarchy = REFERENCE_TYPE_DOCTOR;
        break;
      case 'tab-reference-patient':
        hierarchy = REFERENCE_TYPE_PATIENT;
        break;

      default:
        hierarchy = REFERENCE_TYPE_CLIENT;
        break;
    }

    this.item.hierarquia = hierarchy;
  }

  private setActiveTab(hierarquia: string): void {
    switch (hierarquia) {
      case REFERENCE_TYPE_TEAM:
        this.activeTab = 'tab-reference-team';
        break;
      case REFERENCE_TYPE_DOCTOR:
        this.activeTab = 'tab-reference-doctor';
        break;
      case REFERENCE_TYPE_PATIENT:
        this.activeTab = 'tab-reference-patient';
        break;
      default:
        this.activeTab = 'tab-reference-client';
        break;
    }

    this.setHierarchy(this.activeTab);
  }
}
